module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "follow-us d-none d-xl-block"
  }, [_c('h5', {
    staticClass: "follow-us-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.follow.title')))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibo"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wechat"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16d1c550","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SideMenu/FollowUs.vue
// module id = 621
// module chunks = 1